import { escapeHtml } from '../html.js';
import type { AuthState, AuthenticatedUser } from './model.js';

export function renderSignIn(state: Exclude<AuthState, { status: 'AUTHENTICATED' }>): string {
  const status = authStatus(state);
  return `
    <main class="auth-screen">
      <section class="auth-card" aria-labelledby="sign-in-title">
        <img class="auth-brand-logo" src="/assets/msp-health-logo.png" alt="" aria-hidden="true">
        <h1 class="sr-only" id="sign-in-title">MSP Health</h1>
        <p>Operational health for Positive Output.</p>
        ${status}
        <button class="microsoft-sign-in" type="button" data-sign-in${state.status === 'INITIALIZING' ? ' disabled' : ''}>
          <span class="microsoft-mark" aria-hidden="true"><i></i><i></i><i></i><i></i></span>
          ${state.status === 'INITIALIZING' ? 'Checking session…' : 'Sign in with Microsoft'}
        </button>
      </section>
    </main>
  `;
}

function authStatus(state: Exclude<AuthState, { status: 'AUTHENTICATED' }>): string {
  if (state.status === 'INITIALIZING') {
    return '<p class="auth-status" role="status">Checking your Microsoft session.</p>';
  }
  if (state.status === 'UNAUTHENTICATED' && state.message !== undefined) {
    return `<p class="auth-status" role="status">${escapeHtml(state.message)}</p>`;
  }
  if (state.status === 'ACCESS_DENIED' || state.status === 'AUTHENTICATION_ERROR') {
    return `<p class="auth-status auth-status-error" role="alert">${escapeHtml(state.message)}</p>`;
  }
  return '';
}

export function renderAccountControl(user: AuthenticatedUser): string {
  return `
    <div class="account-shell">
      <button class="account-trigger" type="button" data-account-toggle aria-expanded="false" aria-label="Open account menu">
        <span class="operator-avatar" aria-hidden="true">${initials(user.displayName)}</span>
        <span class="operator-copy">
          <strong>${escapeHtml(user.displayName)}</strong>
          <small>${escapeHtml(user.email)} · ${escapeHtml(user.role)}</small>
        </span>
      </button>
      <div class="account-menu" data-account-menu hidden>
        <div class="account-menu-identity">
          <strong>${escapeHtml(user.displayName)}</strong>
          <span>${escapeHtml(user.email)}</span>
          <small>${escapeHtml(user.tenantName)} · Tenant ${escapeHtml(user.tenantId)}</small>
        </div>
        <div class="account-menu-role"><span>Role</span><strong>${escapeHtml(user.role)}</strong></div>
        <div class="account-menu-role"><span>Profile</span><strong>${escapeHtml(profileLabel(user.operationalProfile))}</strong></div>
        <button type="button" data-sign-out>Sign out</button>
      </div>
    </div>
  `;
}

function profileLabel(profile: AuthenticatedUser['operationalProfile']): string {
  return profile.split('_').map((part) => part.charAt(0) + part.slice(1).toLowerCase()).join(' ');
}

function initials(displayName: string): string {
  return displayName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}
